<template>
  <sidebar
  :addTitle="$t('Decarbonization.ComplexityParameter.AddNew')"
  :editTitle="$t('Decarbonization.ComplexityParameter.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('Decarbonization.ComplexityParameter.Name')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.ComplexityParameter.Name')"
              v-model="name"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.ComplexityParameter.Constant')" rules="required|decimal|between:0,9999999999" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.ComplexityParameter.Constant')"
              v-model="constant"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.ComplexityParameter.Exponent')" rules="required|decimal|between:-9999999999,9999999999" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.ComplexityParameter.Exponent')"
              v-model="exponent"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>

import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

export default {
  props: {    
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      id: 0,
      name: "",
      constant: 0.0,
      exponent: 0.0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, name, constant, exponent } = JSON.parse(JSON.stringify(this.data));
      this.id = id;
      this.name = name;
      this.constant = constant;
      this.exponent = exponent;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;      
      this.name = "";
      this.id = 0;
      this.constant = 0.0;
      this.exponent = 0.0;
    },    
    
    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.id,
            name: this.name,
            constant: this.constant,
            exponent: this.exponent
          };

          this.$vs.loading();
         
          if (this.id !== null && this.id > 0) {
            this.$store.dispatch("decarbonization/updateComplexityParameter", obj).then((result) => {
              this.$emit("onUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("decarbonization/addComplexityParameter", obj).then((result) => {
              this.$emit("onInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
